import {IOption} from "@pg-design/select-module";

import {HomeMatchFinancingPreference} from "../constants/preferences/home_match_preferences_values";
import {IHomeMatchSurveyApiRequest} from "../types/home_match_preferences";
import {IHomeMatchPreferencesWizardSurvey} from "./get_home_match_preferences_wizard_steps";

// Comparable snapshot of the survey props the wizard was last synced with.
interface IAppliedSurvey {
    financingPreference: HomeMatchFinancingPreference | null;
    priceLower: number | null;
    priceUpper: number | null;
    regionOptions: string[];
    regions: number[];
    roomsLower: number | null;
    roomsUpper: number | null;
}

export const getAppliedSurvey = (
    financingPreference: HomeMatchFinancingPreference | null,
    regionOptions: IOption<number>[],
    survey: IHomeMatchPreferencesWizardSurvey | null
): IAppliedSurvey => ({
    financingPreference,
    priceLower: survey?.price?.lower ?? null,
    priceUpper: survey?.price?.upper ?? null,
    regionOptions: regionOptions.map((option) => `${option.value}:${option.label}`),
    regions: survey?.regions ?? [],
    roomsLower: survey?.rooms?.lower ?? null,
    roomsUpper: survey?.rooms?.upper ?? null
});

export const getSavedSurvey = (
    financingPreference: HomeMatchFinancingPreference | null,
    survey: IHomeMatchPreferencesWizardSurvey | null
): Omit<IHomeMatchSurveyApiRequest, "source"> => ({
    ...(financingPreference ? {financing_preference: financingPreference} : {}),
    ...(survey && "construction_end_date" in survey ? {construction_end_date: survey.construction_end_date ?? null} : {}),
    ...(survey?.market_types !== undefined ? {market_types: survey.market_types} : {}),
    price: survey?.price ?? null,
    regions: survey?.regions ?? [],
    rooms: survey?.rooms ?? null,
    ...(survey?.types !== undefined ? {types: survey.types} : {})
});

const sameList = <T extends number | string>(left: T[], right: T[]) => left.length === right.length && left.every((value, index) => value === right[index]);

export const surveysMatch = (left: IAppliedSurvey, right: IAppliedSurvey) =>
    left.financingPreference === right.financingPreference &&
    left.priceLower === right.priceLower &&
    left.priceUpper === right.priceUpper &&
    left.roomsLower === right.roomsLower &&
    left.roomsUpper === right.roomsUpper &&
    sameList(left.regions, right.regions) &&
    sameList(left.regionOptions, right.regionOptions);
import {IOption} from "@pg-design/select-module";

import {HomeMatchFinancingPreference} from "../constants/preferences/home_match_preferences_values";
import {IHomeMatchSurveyApiRequest} from "../types/home_match_preferences";
import {IHomeMatchPreferencesWizardSurvey} from "./get_home_match_preferences_wizard_steps";

// Comparable snapshot of the survey props the wizard was last synced with.
interface IAppliedSurvey {
    financingPreference: HomeMatchFinancingPreference | null;
    priceLower: number | null;
    priceUpper: number | null;
    regionOptions: string[];
    regions: number[];
    roomsLower: number | null;
    roomsUpper: number | null;
}

export const getAppliedSurvey = (
    financingPreference: HomeMatchFinancingPreference | null,
    regionOptions: IOption<number>[],
    survey: IHomeMatchPreferencesWizardSurvey | null
): IAppliedSurvey => ({
    financingPreference,
    priceLower: survey?.price?.lower ?? null,
    priceUpper: survey?.price?.upper ?? null,
    regionOptions: regionOptions.map((option) => `${option.value}:${option.label}`),
    regions: survey?.regions ?? [],
    roomsLower: survey?.rooms?.lower ?? null,
    roomsUpper: survey?.rooms?.upper ?? null
});

export const getSavedSurvey = (
    financingPreference: HomeMatchFinancingPreference | null,
    survey: IHomeMatchPreferencesWizardSurvey | null
): Omit<IHomeMatchSurveyApiRequest, "source"> => ({
    ...(financingPreference ? {financing_preference: financingPreference} : {}),
    ...(survey && "construction_end_date" in survey ? {construction_end_date: survey.construction_end_date ?? null} : {}),
    ...(survey?.market_types !== undefined ? {market_types: survey.market_types} : {}),
    price: survey?.price ?? null,
    regions: survey?.regions ?? [],
    rooms: survey?.rooms ?? null,
    ...(survey?.types !== undefined ? {types: survey.types} : {})
});

const sameList = <T extends number | string>(left: T[], right: T[]) => left.length === right.length && left.every((value, index) => value === right[index]);

export const surveysMatch = (left: IAppliedSurvey, right: IAppliedSurvey) =>
    left.financingPreference === right.financingPreference &&
    left.priceLower === right.priceLower &&
    left.priceUpper === right.priceUpper &&
    left.roomsLower === right.roomsLower &&
    left.roomsUpper === right.roomsUpper &&
    sameList(left.regions, right.regions) &&
    sameList(left.regionOptions, right.regionOptions);
